export default "__VITE_ASSET__BHk5cVb7__"